var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex w-full flex-col bg-white border shadow-sm overflow-hidden border-gray-100 rounded-2xl p-0 mt-0"
  }, [_c('div', {
    staticClass: "w-full overflow-x-auto relative min-h-custom"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "absolute min-h-custom bg-white inset-0 bg-white/70 z-10 flex items-center justify-center rounded-xl"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _vm._e(), _c('table', {
    staticClass: "w-full text-left border-collapse"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "divide-y divide-gray-100 text-sm font-medium text-gray-800"
  }, [_vm._l(_vm.contents, function (content, index) {
    var _content$total_readin;
    return _c('tr', {
      key: content.item_id || index,
      staticClass: "hover:bg-gray-50/80 transition-colors"
    }, [_c('td', {
      staticClass: "py-3 px-3 text-gray-500 font-normal"
    }, [_vm._v(" " + _vm._s(index + 1) + " ")]), _c('td', {
      staticClass: "py-3 px-3 w-full font-normal text-gray-500",
      attrs: {
        "title": content.content_title || '-'
      }
    }, [_c('div', {
      staticClass: "w-52"
    }, [_vm._v(" " + _vm._s(_vm.truncateText(content.content_title)) + " ")])]), _c('td', {
      staticClass: "py-3 px-3 w-full font-normal text-gray-500",
      attrs: {
        "title": content.author || '-'
      }
    }, [_c('div', {
      staticClass: "w-52"
    }, [_vm._v(" " + _vm._s(_vm.truncateText(content.author)) + " ")])]), _c('td', {
      staticClass: "py-3 px-3 text-left text-gray-500 font-normal"
    }, [_vm._v(" " + _vm._s((_content$total_readin = content.total_reading) !== null && _content$total_readin !== void 0 ? _content$total_readin : 0) + " ")])]);
  }), !_vm.isLoading && _vm.contents.length === 0 ? _c('tr', [_vm._m(1)]) : _vm._e()], 2)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "border-b bg-gray-50 border-gray-200 text-xs font-medium text-gray-500 uppercase bg-gray-50/50"
  }, [_c('th', {
    staticClass: "py-3 px-3 rounded-l-lg"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "py-3 px-3"
  }, [_vm._v("Content Title")]), _c('th', {
    staticClass: "py-3 px-3 text-left"
  }, [_vm._v("author")]), _c('th', {
    staticClass: "py-3 px-3 text-left"
  }, [_vm._v(" total reading ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('td', {
    staticClass: "py-8 text-center text-gray-400 text-sm",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "flex flex-col items-center justify-center space-y-2"
  }, [_c('div', {
    staticClass: "flex h-36 justify-center w-full flex-col items-center space-y-2 rounded-xl"
  }, [_c('div', [_c('img', {
    staticClass: "w-12",
    attrs: {
      "src": require("../../assets/img/empty_smartpin.png"),
      "alt": ""
    }
  })]), _c('p', {
    staticClass: "text-sm text-center font-medium text-gray-800"
  }, [_vm._v("No Data Yet")]), _c('p', {
    staticClass: "text-xs m-0 text-center font-normal text-gray-500"
  }, [_vm._v("Client has no activity yet.")])])])]);
}]

export { render, staticRenderFns }